import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledPartners = styled.div`
    padding: 120px 0 0;
    position: relative;
    background: ${theme.colors.themeColor5};
    margin-top: -1px;
    .swiper-container-free-mode > .swiper-wrapper{
        transition-timing-function : linear;
    }
    .swiper-slide {
        overflow: hidden;
        background-position: center center;
        background-size: cover;
    }

    .swiper-grid > .swiper-wrapper {
        padding-bottom: 2px;
    }


    .heading-title {
        .navigation {
            svg {
                margin: 0 !important;
            }

            ${devices.sm} {
                margin-top: 40px;
            }
        }

        ${devices.sm}) {
        flex-direction: column;

        .title {
            margin-bottom: 0;
        }

        .desktop-navigation {
            margin-bottom: 40px;
            display: none;
        }

    }
    }

    .main-container {
        .country-nation {
            svg, img {
                height: 100%;
                width: auto !important;
                @media(max-width: 767px){
                    width: 100%;
                }
            }

            ${devices.md} {
                margin-top: 40px;
            }
        }

        ${devices.md} {
            padding: 0 15px !important;

            .row {
                flex-direction: column-reverse;

                > div {
                    width: 100%;
                    padding: 0 15px !important;

                    svg {
                        width: 100%;
                        margin-top: 40px;
                    }
                }
            }
        }
    }

    .mobile-navigation {
        ${theme.displayNone}
    }

    ${devices.sm} {
        padding-top: 80px;
        .mobile-navigation {
            ${theme.displayNone}
            margin-bottom: 60px;
        }

        .justify-content-between{
            flex-direction: column;
            .navigation{
                margin-bottom: 40px;
            }
            .title{
                margin-bottom: 0;
            }
        }
    }

`;
